import React, { useEffect, useState } from "react";
import { Link, useLoaderData, useNavigation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { PhotoProvider, PhotoView } from "react-photo-view";
import Reviews from "../Reviews/Reviews";
import ReviewCard from "../ReviewCard/ReviewCard";
import Loader from "../../Pages/Shared/Loader/Loader";
import { MdStar } from "react-icons/md";
import "./ServiceDetails.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { TypeAnimation } from "react-type-animation";

const ServiceDetails = () => {
  const serviceDetails = useLoaderData();
  const { _id, title, description, price, img } = serviceDetails;

  const navigation = useNavigation();

  const [loading, setLoading] = useState(false);
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    setLoading(true);
    fetch(`https://food-for-you-server.vercel.app/reviews`)
      .then((res) => res.json())
      .then((data) => {
        setReviews(data);
        setLoading(false);
      });
  }, []);

  const selectedReviews = reviews.filter((r) => r.serviceName === title);

  const arrRatingsStr = selectedReviews.map((sr) => sr.ratings);
  const arrRatingsNum = arrRatingsStr.map(Number);
  const sumRatings = arrRatingsNum.reduce(function (acc, score) {
    return acc + score;
  }, 0);

  const reviewLength = selectedReviews.length;
  let avgRatings = sumRatings / reviewLength;
  avgRatings = avgRatings.toFixed(1);
  console.log("avgRatings:", avgRatings);

  if (isNaN(avgRatings)) {
    avgRatings = 0;
  }

  if (navigation.state === "loading") {
    return <Loader></Loader>;
  }

  return (
    <div>
      {loading ? (
        <Loader></Loader>
      ) : (
        <div className="d-flex flex-column flex-md-row gap-3 m-service-details">
          <div>
            <Container data-aos="fade-right" data-aos-duration="2000">
              <Row>
                <Col className="rounded-2 mb-5 servic">
                  <div className="row row-cols-1 row-cols-md-1 row-cols-lg-1 g-4 service-detail">
                    <div className="col mx-auto">
                      <div className="card p-3 p-md-4 pb-3 rounded-3 border-0 shadow-lg">
                        <PhotoProvider
                          speed={() => 800}
                          easing={(type) =>
                            type === 2
                              ? "cubic-bezier(0.36, 0, 0.66, -0.56)"
                              : "cubic-bezier(0.34, 1.56, 0.64, 1)"
                          }
                        >
                          <PhotoView src={img}>
                            <LazyLoadImage
                              src={img}
                              alt={title}
                              placeholderSrc={img}
                              className="card-img-top bg-dark rounded-3 card-log service-details-img"
                              // height="400px"
                              effect="blur"
                              title="Click to see the full size photo"
                              style={{ objectFit: "cover", cursor: "pointer" }}
                            />
                          </PhotoView>
                        </PhotoProvider>

                        <div className="card-body p-2 pt-4">
                          <h4 className="card-title fw-bold mb-3">
                            Name: {title}
                          </h4>

                          <h5 className="card-text mb-3 ">
                            <b>Average Ratings:</b>

                            {avgRatings === 0 ? (
                              <span className="text-danger ms-1 fs-my-1 fw-bold">
                                No Ratings
                              </span>
                            ) : (
                              <span className="fw-bold text-primary mx-1">
                                <span className="">{avgRatings}</span>
                                <span>
                                  <MdStar className="orange-color fs-4 mb-1" />
                                </span>
                              </span>
                            )}
                          </h5>

                          <h5 className="card-text mb-3 ">
                            <b>Total Reviews:</b>

                            {reviewLength === 0 ? (
                              <span className="text-danger ms-1 fs-my-1 fw-bold">
                                No Reviews
                              </span>
                            ) : (
                              <span className="fw-bold text-primary mx-1">
                                {reviewLength}
                              </span>
                            )}
                          </h5>

                          <h5 className="card-text mb-3 ">
                            <b>Price:</b>
                            <span className="fw-bold text-primary mx-1 fs-my-2">
                              ${price}
                            </span>
                          </h5>

                          <div className="card-text">
                            <p className="text-decoration-underlin mb-1 fw-bold fs-5">
                              Description:
                            </p>
                            {description}
                          </div>

                          <Link to={`/payment/${_id}`}>
                            <button className="btn btn-primary bg-gradient btn-width mt-3">
                              <span className="d-flex justify-content-between">
                                <div className="fw-semibold">Order Now</div>
                              </span>
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>

          <div className="service-details">
            <Reviews></Reviews>

            <div data-aos="fade-up" data-aos-duration="2000">
              <h3 className="form-header fw-bolder m-cus mt-5 mb-3 fs-5">
                <TypeAnimation
                  sequence={[`All Reviews (${selectedReviews.length})`, 3000]}
                  speed={40}
                  cursor={false}
                  repeat={Infinity}
                />
              </h3>

              {selectedReviews.length === 0 ? (
                <h3 className="form-header text-danger fw-bold ms-3 mt-4 mb-3 fs-5 d-flex justify-content-center align-items-center text-center">
                  <TypeAnimation
                    sequence={[
                      "This food has no reviews yet. Please give first review!",
                      3000,
                    ]}
                    speed={50}
                    cursor={false}
                    repeat={Infinity}
                  />
                </h3>
              ) : (
                <div className="row row-cols-1 g-3 mb-0 mb-md-5">
                  {selectedReviews.map((review) => (
                    <ReviewCard key={review._id} review={review}></ReviewCard>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceDetails;
